// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__I9aI4","header":"MessagesList_header__1B74P","chat":"MessagesList_chat__2bfts"};